import { createAsyncSliceWithDataAndQuery } from '../../createAsyncSliceWithDataAndQuery';
import { getJournalEntriesAsync } from '../../../API/accounting/getJournalEntriesAsync';
import { createDefaultPageData } from 'types/rest/IPageData';

export const { slice: journalEntriesSlice, asyncAction: loadJournalEntriesAction } = createAsyncSliceWithDataAndQuery(
  'journalEntriesSlice',
  getJournalEntriesAsync,
  createDefaultPageData()
);
